<div class="container">
  <mat-form-field color="accent" class="filter">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container *ngFor="let column of dynamicColumn" [matColumnDef]="column.property">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.display }}</th>
      <td mat-cell *matCellDef="let element">{{ element[column.property] }}</td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Download File</th>
      <td mat-cell *matCellDef="let element">
        <a mat-stroked-button [href]="element.download" rel="noopener">Download</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div class="spinner" *ngIf="loading">
    <mat-progress-spinner color="accent" mode="indeterminate" strokeWidth="10" diameter="75"> </mat-progress-spinner>
  </div>
</div>
